import { useGetSubscriptionPackages } from '@bpm-web-app/swr-hooks';

export const usePlans = (platform: 'supreme' | 'create') => {
    const { data: packages } = useGetSubscriptionPackages(platform, false);

    return { packages };
};
